import { createApp } from 'vue'
import { createPinia } from 'pinia'
// Element Plus components are auto-imported on demand (see vite.config.ts); only its stylesheet is
// pulled in wholesale, so that our override below has a deterministic order to win against.
import 'element-plus/dist/index.css'

// Brand tokens first, then the Element Plus override, then the base layer: later files depend on the
// custom properties declared by earlier ones, and the Element override must come after its own CSS.
import '@/assets/styles/brand.css'
import '@/assets/styles/element-theme.css'
import '@/assets/styles/base.css'

import App from '@/App.vue'
import { router } from '@/router'
import { i18n } from '@/locales'
import { setSessionExpiredHandler } from '@/api/http'
import { useAuthStore } from '@/store/authStore'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

// The http layer cannot import the router or the store without a cycle, so the app wires the
// "session is gone" path here.
setSessionExpiredHandler(() => {
  useAuthStore().forget()
  const current = router.currentRoute.value
  if (current.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect: current.fullPath, expired: '1' } })
  }
})

app.mount('#app')
